import SettingsProperty from './SettingsProperty';

export default SettingsProperty;
